import Action from '../Action';
import { useEffect, useState } from 'react';
import LoadSimple from '../LoadSimple';
import { capitalizeFirstLetter } from '../../utils/utils';
import { useFetch } from '../../hooks/useFetch';
import { lang } from '../generales/traduction';
import Search from '../generales/Search';
import Paginador from '../generales/Paginador';
import SelectorAdmin from '../SelectorAdmin';

const ModalAddGroup = ({ editActive, tab, search_tabs, event, languaje, search_problems, appSelected, server, mode, setPoolRows, poolObjectRows, setPoolObjectRows, poolRows, handleShowPopup, closeAddHostModal }) => {
  const [hosts, setHosts] = useState({
    data: [],
    loading: true,
    error: null,
  })
  const [dataEvent, setDataEvent] = useState({
    data: [],
    loading: false,
    error: null,
  })
  const [responseAction, setResponseAction] = useState({
    data: [],
    loading: false,
    error: null,
  })
  const [loading, setLoading] = useState(false)
  const [ManttoData, setManttoData] = useState({
    name: (editActive) ? tab.name : "",
    type: "",
    eventids: []
  })
  const [ManttoDataAux, setManttoDataAux] = useState({
    name: "",
    type: "",
    eventids: []
  })
  const [disable, setDisable] = useState(true)

  useEffect(() => {
    buscar_cis();
  }, []);

  useEffect(() => {
    if (editActive) {
      setPoolRows(tab.group_ids)
      const filtered = (hosts.loading) ? [] : hosts.data.filter(item => tab.group_ids.includes(item.groupid));
      setPoolObjectRows(filtered)
    }
  }, [hosts.loading])

  useEffect(() => {
    if (ManttoData.name == "" || poolRows.length == 0) {
      setDisable(true)
    } else {
      setDisable(false)
    }
  }, [ManttoData, poolRows])

  const buscar_cis = () => {
    setHosts({
      data: hosts.data,
      loading: true,
      error: hosts.error,
    });

    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url + "/api/v1/cassia/host_groups/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setHosts({
            data: data1.data,
            loading: false,
            error: hosts.error,
          });
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const registrar = () => {
    setResponseAction({
      data: responseAction.data,
      loading: true,
      error: responseAction.error,
    });

    const data = {
      id: ManttoData.name,
      name: ManttoData.name,
      group_ids: poolRows
    }

    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url + "/api/v1/cassia/monitoring_devices/status_report/custom-tabs/" + ((editActive) ? tab.id : ''),
          {
            method: (editActive) ? "PUT" : "POST",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
            body: JSON.stringify(data)
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setResponseAction({
            data: data1,
            loading: false,
            error: responseAction.error,
          });
          setPoolObjectRows([])
          setPoolRows([])
          search_tabs()
          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), '', data1.message, true)
          closeAddHostModal()
          search_problems()
        } else {
          const data1 = await response.json();
          setResponseAction({
            data: responseAction.data,
            loading: false,
            error: responseAction.error,
          });
          handleShowPopup('Error!!!', capitalizeFirstLetter(lang[languaje]['errorActionComplet']), data1.detail, false)
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const [allSelected, setAllSelected] = useState(false);
  const [hostSelected, setHostSelected] = useState([])
  const [contRowsSelected, setContRowSelected] = useState(0)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  var dataList = searchTerm === "" ? hosts.data : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;

  const handleSelectAll = () => {
    if (allSelected) {
      setPoolRows([]);
      setPoolObjectRows([])
    } else {
      setPoolRows(dataList.map(item => item.groupid))
      setPoolObjectRows(dataList)
    }
    setAllSelected(!allSelected);
  };

  const handleSearch = (query) => {
    setSearchResult(`Resultados para: ${query}`);
  };

  const handleSelectChange = (e) => {
    setPageActual(1)
    setLimitList(e.target.value);
    setPageActual(1);
  };

  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }

    setPoolRows((prevRows) => {
      const exists = prevRows.includes(elemento.groupid);
      if (exists) {
        return prevRows.filter(groupid => groupid !== elemento.groupid);
      } else {
        return [...prevRows, elemento.groupid];
      }
    });

    setPoolObjectRows((prevRows) => {
      const getId = (obj) => obj?.groupid ?? obj?.groupid;
      const newId = getId(elemento);
      const exists = prevRows.some(evento => getId(evento) === newId);
      if (exists) {
        return prevRows.filter(evento => getId(evento) !== newId);
      } else {
        return [...prevRows, elemento];
      }
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target
    setManttoData((prevState) => {
      return {
        ...prevState,
        [name]: value
      }
    })
  }

  const changeOption = (option, index) => {
    setManttoData((prevState) => {
      return {
        ...prevState,
        ['type']: option.label
      }
    })
  }

  const { name, type } = ManttoData;

  return (
    <>
      <div style={{
        width: '100%',
        height: '100%',
        fontFamily: "'DM Sans', system-ui, sans-serif",
        display: 'flex',
        flexDirection: 'column',
        background: mode === 'Dark' ? '#0f172a' : '#fff',
        borderRadius: 12,
        overflow: 'hidden'
      }}>

        {/* HEADER AZUL MARINO OSCURO */}
        <div style={{
          background: 'linear-gradient(135deg, #1e3a5f 0%, #0f2d5e 100%)',
          padding: '12px 28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'relative',
          height: '5%',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            {/* Ícono */}
            <div style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '2px solid rgba(255, 255, 255, 0.3)'
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>

            <div>
              <h2 style={{
                fontSize: 20,
                fontWeight: 600,
                color: '#fff',
                margin: 0,
                marginBottom: 4
              }}>
                {editActive ? capitalizeFirstLetter(lang[languaje]['editar']) : capitalizeFirstLetter(lang[languaje]['crear'])} {capitalizeFirstLetter(lang[languaje]['grupo'])}
              </h2>
              <p style={{
                fontSize: 13,
                color: 'rgba(255, 255, 255, 0.7)',
                margin: 0
              }}>
                {/* {editActive ? 'Modificar grupos existentes' : 'Registrar reconocimiento del grupo'} */}
              </p>
            </div>
          </div>

          {/* Botón cerrar */}
          <button
            onClick={closeAddHostModal}
            style={{
              width: 36,
              height: 36,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              fontSize: 20,
              transition: 'all 0.2s'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
            }}
          >
            ×
          </button>
        </div>

        {dataEvent.loading ? (
          <div style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <LoadSimple />
          </div>
        ) : (
          <>
            {/* INPUT NOMBRE */}
            <div style={{
              padding: '0px 28px',
              borderBottom: '1px solid #e2e8f0'
            }}>
              <div style={{ marginBottom: 20 }}>
                <label style={{
                  display: 'block',
                  fontSize: 12,
                  fontWeight: 600,
                  color: mode === 'Dark' ? '#94a3b8' : '#64748b',
                  marginBottom: 8,
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  {capitalizeFirstLetter(lang[languaje]['nombre'])}
                </label>
                <input
                  required
                  name="name"
                  type="text"
                  value={name}
                  onChange={handleChange}
                  placeholder="Nombre del grupo"
                  style={{
                    width: '95%',
                    padding: '12px 16px',
                    fontSize: 10,
                    border: '1px solid #e2e8f0',
                    borderRadius: 8,
                    outline: 'none',
                    background: mode === 'Dark' ? '#1e293b' : '#fff',
                    color: mode === 'Dark' ? '#f1f5f9' : '#0f172a',
                    transition: 'border-color 0.2s, box-shadow 0.2s'
                  }}
                  onFocus={e => {
                    e.target.style.borderColor = '#1a56db';
                    e.target.style.boxShadow = '0 0 0 3px rgba(26, 86, 219, 0.1)';
                  }}
                  onBlur={e => {
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>

              {/* Info alert */}
              <div style={{
                background: '#eff6ff',
                border: '1px solid #bfdbfe',
                borderRadius: 8,
                padding: '12px 16px',
                display: 'flex',
                gap: 12
              }}>
                <div style={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  background: '#3b82f6',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 14,
                  fontWeight: 600,
                  flexShrink: 0
                }}>
                  i
                </div>
                <p style={{
                  margin: 0,
                  fontSize: 13,
                  color: '#1e40af',
                  lineHeight: 1.5
                }}>
                  Seleccione los dispositivos que agregara al grupo.
                </p>
              </div>
            </div>

            {/* CONTENIDO PRINCIPAL */}
            <div style={{
              flex: 1,
              display: 'flex',
              gap: 20,
              padding: '20px 28px',
              overflow: 'hidden',
              background: mode === 'Dark' ? '#0f172a' : '#f8fafc'
            }}>

              {/* TABLA IZQUIERDA */}
              <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                background: mode === 'Dark' ? '#1e293b' : '#fff',
                borderRadius: 12,
                border: '1px solid #e2e8f0',
                overflow: 'hidden'
              }}>
                {/* Search */}
                <div style={{ padding: '7px 20px', borderBottom: '1px solid #e2e8f0' }}>
                  <Search
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    onSearch={handleSearch}
                    dataObject={hosts.data}
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    languaje={languaje}
                  />
                </div>

                {/* Tabla */}
                <div style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
                  {/* Header */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '50px 80px 1fr 150px',
                    background: '#0f2d5e',
                    color: '#fff',
                    padding: '12px 16px',
                    fontSize: 11,
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <input
                        type='checkbox'
                        checked={allSelected}
                        onChange={handleSelectAll}
                        style={{
                          width: 16,
                          height: 16,
                          cursor: 'pointer'
                        }}
                      />
                    </div>
                    <div>Group ID</div>
                    <div>{capitalizeFirstLetter(lang[languaje]['nombre'])}</div>
                    <div>{capitalizeFirstLetter(lang[languaje]['tipo'])}</div>
                  </div>

                  {/* Body */}
                  <div style={{ flex: 1 }}>
                    {hosts.loading ? (
                      <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%'
                      }}>
                        <LoadSimple />
                      </div>
                    ) : (
                      <>
                        {dataList.slice(startLimit, parseInt(pageActual) * parseInt(limitList)).map((elemento, indice) => (
                          <div
                            key={indice}
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '50px 80px 1fr 150px',
                              padding: '12px 16px',
                              fontSize: 12,
                              borderBottom: '1px solid #f1f5f9',
                              background: indice % 2 === 0
                                ? (mode === 'Dark' ? '#1e293b' : '#fff')
                                : (mode === 'Dark' ? '#0f172a' : '#fafafa'),
                              cursor: 'pointer',
                              transition: 'background 0.15s'
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = mode === 'Dark' ? '#334155' : '#f8fafc'}
                            onMouseLeave={e => e.currentTarget.style.background = indice % 2 === 0
                              ? (mode === 'Dark' ? '#1e293b' : '#fff')
                              : (mode === 'Dark' ? '#0f172a' : '#fafafa')}
                            onClick={() => rowSelected(elemento)}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <input
                                type='checkbox'
                                checked={poolRows.some((row) => row === elemento.groupid)}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  rowSelected(elemento);
                                }}
                                style={{
                                  width: 16,
                                  height: 16,
                                  cursor: 'pointer'
                                }}
                              />
                            </div>
                            <div style={{
                              color: mode === 'Dark' ? '#cbd5e1' : '#64748b',
                              fontFamily: "'DM Mono', monospace"
                            }}>
                              {elemento.groupid}
                            </div>
                            <div style={{
                              color: mode === 'Dark' ? '#f1f5f9' : '#0f172a',
                              fontWeight: 500
                            }}>
                              {elemento.group_name}
                            </div>
                            <div style={{
                              color: mode === 'Dark' ? '#94a3b8' : '#64748b',
                              fontSize: 11
                            }}>
                              {elemento.group_type_name}
                            </div>
                          </div>
                        ))}
                        {dataList.length === 0 && (
                          <div style={{
                            padding: 40,
                            textAlign: 'center',
                            color: '#94a3b8',
                            fontSize: 14
                          }}>
                            {capitalizeFirstLetter(lang[languaje]['sinResultados'])}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>

                {/* Footer/Paginador */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '12px 20px',
                  borderTop: '1px solid #e2e8f0',
                  background: mode === 'Dark' ? '#1e293b' : '#fff',
                  flexWrap: 'wrap',
                  gap: 12
                }}>
                  <Paginador
                    pages={pages}
                    pageActual={pageActual}
                    setPageActual={setPageActual}
                    mode={mode}
                  />
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    fontSize: 12
                  }}>
                    <label htmlFor="selector" style={{ color: mode === 'Dark' ? '#cbd5e1' : '#64748b' }}>
                      {capitalizeFirstLetter(lang[languaje]['filasPagina'])}:
                    </label>
                    <select
                      id="selector"
                      value={limitList}
                      onChange={handleSelectChange}
                      style={{
                        padding: '6px 10px',
                        border: '1px solid #e2e8f0',
                        borderRadius: 6,
                        fontSize: 12,
                        background: mode === 'Dark' ? '#0f172a' : '#fff',
                        color: mode === 'Dark' ? '#f1f5f9' : '#0f172a',
                        cursor: 'pointer'
                      }}
                    >
                      <option value={10}>10</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                    <span style={{ color: mode === 'Dark' ? '#94a3b8' : '#64748b' }}>
                      ({startLimit + 1} - {dataList.length > parseInt(pageActual) * parseInt(limitList)
                        ? parseInt(pageActual) * parseInt(limitList)
                        : dataList.length}) {lang[languaje]['de']} {dataList.length}
                    </span>
                  </div>
                </div>
              </div>

              {/* PANEL DERECHO - SELECCIONADOS */}
              <div style={{
                width: 400,
                display: 'flex',
                flexDirection: 'column',
                background: mode === 'Dark' ? '#1e293b' : '#fff',
                borderRadius: 12,
                border: '1px solid #e2e8f0',
                overflow: 'hidden'
              }}>
                {/* Header con botones */}
                <div style={{
                  padding: '0px',
                  borderBottom: '1px solid #e2e8f0',
                  display: 'flex',
                  gap: 12
                }}>
                  {responseAction.loading ? (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '20px 0' }}>
                      <LoadSimple />
                    </div>
                  ) : (
                    <>
                      {/* <button
                        onClick={closeAddHostModal}
                        style={{
                          flex: 1,
                          padding: '12px 20px',
                          background: mode === 'Dark' ? '#1e293b' : '#fff',
                          color: mode === 'Dark' ? '#f1f5f9' : '#0f172a',
                          border: '1px solid #e2e8f0',
                          borderRadius: 8,
                          fontSize: 14,
                          fontWeight: 500,
                          cursor: 'pointer',
                          transition: 'all 0.2s'
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.background = mode === 'Dark' ? '#334155' : '#f8fafc';
                          e.currentTarget.style.borderColor = '#cbd5e1';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.background = mode === 'Dark' ? '#1e293b' : '#fff';
                          e.currentTarget.style.borderColor = '#e2e8f0';
                        }}
                      >
                        {capitalizeFirstLetter(lang[languaje]['cancelar'])}
                      </button> */}
                      <button
                        disabled={disable}
                        onClick={registrar}
                        style={{
                          flex: 1,
                          padding: '12px 20px',
                          background: disable ? '#cbd5e1' : '#1a56db',
                          color: '#fff',
                          border: 'none',
                          borderRadius: 8,
                          fontSize: 14,
                          fontWeight: 500,
                          cursor: disable ? 'not-allowed' : 'pointer',
                          transition: 'background 0.2s',
                          opacity: disable ? 0.6 : 1
                        }}
                        onMouseEnter={e => !disable && (e.currentTarget.style.background = '#0f2d5e')}
                        onMouseLeave={e => !disable && (e.currentTarget.style.background = '#1a56db')}
                      >
                        {editActive ? capitalizeFirstLetter(lang[languaje]['editar']) : capitalizeFirstLetter(lang[languaje]['crear'])} {capitalizeFirstLetter(lang[languaje]['grupo'])}
                      </button>
                    </>
                  )}
                </div>

                {/* Título */}
                <div style={{
                  background: '#0f2d5e',
                  color: '#fff',
                  padding: '12px 20px',
                  fontSize: 13,
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  {capitalizeFirstLetter(lang[languaje]['gruposSeleccionados'])}
                </div>

                {/* Lista de seleccionados */}
                <div style={{ flex: 1, overflow: 'auto', padding: 16 }}>
                  {poolObjectRows.length === 0 ? (
                    <div style={{
                      padding: 40,
                      textAlign: 'center',
                      color: '#94a3b8',
                      fontSize: 14
                    }}>
                      {capitalizeFirstLetter(lang[languaje]['sinResultados'])}
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {poolObjectRows.map((elemento, indice) => (
                        <div
                          key={indice}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '12px 14px',
                            background: mode === 'Dark' ? '#0f172a' : '#f8fafc',
                            border: '1px solid #e2e8f0',
                            borderRadius: 8,
                            fontSize: 12,
                            gap: 12
                          }}
                        >
                          <span style={{
                            flex: 1,
                            color: mode === 'Dark' ? '#f1f5f9' : '#0f172a',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}>
                            {elemento.groupid} / {elemento.group_name} / {elemento.group_type_name}
                          </span>
                          <button
                            onClick={() => rowSelected(elemento)}
                            style={{
                              width: 24,
                              height: 24,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              background: 'transparent',
                              border: 'none',
                              color: '#db2777',
                              fontSize: 18,
                              fontWeight: 600,
                              cursor: 'pointer',
                              borderRadius: 4,
                              transition: 'all 0.2s',
                              flexShrink: 0
                            }}
                            onMouseEnter={e => {
                              e.currentTarget.style.background = 'rgba(219, 39, 119, 0.1)';
                            }}
                            onMouseLeave={e => {
                              e.currentTarget.style.background = 'transparent';
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Footer contador */}
                <div style={{
                  padding: '12px 20px',
                  borderTop: '1px solid #e2e8f0',
                  textAlign: 'center',
                  fontSize: 12,
                  color: mode === 'Dark' ? '#94a3b8' : '#64748b',
                  background: mode === 'Dark' ? '#1e293b' : '#fff'
                }}>
                  ({poolRows.length}) {capitalizeFirstLetter(lang[languaje]['registosSeleccionados'])}
                </div>
              </div>

            </div>
          </>
        )}

      </div>
    </>
  );
}

export default ModalAddGroup